import AttendanceTypeToSchedule from "../views/toSchedule/AttendanceType";
import CitiesSupportedToSchedule from "../views/toSchedule/CitiesSupported";
import SpecialtiesToSchedule from "../views/toSchedule/Specialties";
import PaymentMethodsToSchedule from "../views/toSchedule/PaymentMethod";
import PaymentTypesToSchedule from "../views/toSchedule/PaymentType";
import InsuranceToSchedule from "../views/toSchedule/Insurance";
import ProfessionalsToSchedule from "../views/toSchedule/Professionals";
import LoginSchedule from "../views/toSchedule/Login";
import RegisterSchedule from "../views/toSchedule/Register";
import PatientToSchedule from "../views/toSchedule/Patient";
import CancelingPolicyToSchedule from "../views/toSchedule/CancelingPolicy";
import PaymentToSchedule from "../views/toSchedule/Payment";
import ScheduledToSchedule from "../views/toSchedule/Scheduled";
import PixFailToSchedule from "../views/toSchedule/PixFail";
import Pix from "../views/toSchedule/Pix.vue";
import PreLoginRegister from "../views/toSchedule/PreLoginRegister.vue";
import ExamPreparation from "../views/toSchedule/ExamPreparation.vue";
import RememberPayment from "../views/toSchedule/RememberPayment.vue";
import ExamType from "@/views/toSchedule/exams/ExamType.vue";
import ScheduleExams from "@/views/toSchedule/exams/Exams.vue";
import ExamPlaces from "@/views/toSchedule/exams/ExamPlaces.vue";
import ExamPaymentMethod from "@/views/toSchedule/exams/ExamPaymentMethod.vue";
import ExamCities from "@/views/toSchedule/exams/ExamCities.vue";
import ExamPatient from "@/views/toSchedule/exams/ExamPatient.vue";
import ExamPayment from "@/views/toSchedule/exams/ExamPayment.vue";
import ExamInsurance from "@/views/toSchedule/exams/ExamInsurance.vue";
import SpecGroup from "@/views/toSchedule/SpecGroup.vue";

const routes = [
    {
        path: '/',
        name: 'AttendanceTypeToSchedule',
        component: AttendanceTypeToSchedule,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/exams/cities',
        name: 'ExamCities',
        component: ExamCities,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/exams/types',
        name: 'ExamType',
        component: ExamType,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/specialty-groups',
        name: 'SpecGroup',
        component: SpecGroup,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/exams/payment-methods',
        name: 'ExamPaymentMethod',
        component: ExamPaymentMethod,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/exams/insurances',
        name: 'ExamInsurance',
        component: ExamInsurance,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/exams/search',
        name: 'ScheduleExams',
        component: ScheduleExams,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/exams/places',
        name: 'ScheduleExamPlaces',
        component: ExamPlaces,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/exams/patients',
        name: 'ExamPatient',
        component: ExamPatient,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/exams/payment',
        name: 'ExamPayment',
        component: ExamPayment,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/place/:id',
        name: 'PlaceAttendanceTypeToSchedule',
        component: AttendanceTypeToSchedule,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/cities',
        name: 'CitiesSupportedToSchedule',
        component: CitiesSupportedToSchedule,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/specialties',
        name: 'SpecialtiesToSchedule',
        component: SpecialtiesToSchedule,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/payment-methods',
        name: 'PaymentMethodsToSchedule',
        component: PaymentMethodsToSchedule,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/payment-types',
        name: 'PaymentTypesToSchedule',
        component: PaymentTypesToSchedule,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/insurances',
        name: 'InsuranceToSchedule',
        component: InsuranceToSchedule,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/professionals',
        name: 'ProfessionalsToSchedule',
        component: ProfessionalsToSchedule,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/schedule/login',
        name: 'LoginSchedule',
        component: LoginSchedule,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/schedule/pre-signin',
        name: 'PreLoginRegister',
        component: PreLoginRegister,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/schedule/register',
        name: 'RegisterSchedule',
        component: RegisterSchedule,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/schedule/patients',
        name: 'PatientToSchedule',
        component: PatientToSchedule,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/canceling-policies',
        name: 'CancelingPolicyToSchedule',
        component: CancelingPolicyToSchedule,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/payment',
        name: 'PaymentToSchedule',
        component: PaymentToSchedule,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/pix',
        name: 'PixToSchedule',
        component: Pix,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/schedules/:id/payment',
        name: 'RememberPayment',
        component: RememberPayment,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/scheduled',
        name: 'ScheduledToSchedule',
        component: ScheduledToSchedule,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/pix-fail',
        name: 'PixFailToSchedule',
        component: PixFailToSchedule,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/exam-preparation/:infos',
        name: 'ExamPreparation',
        component: ExamPreparation,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
];

export default routes